import React from 'react'
import { OutboundLink } from 'react-ga'

const ItemCardFeatureRecap = ({ item }) => {
  return (
    <article className="card featureCard">
      <div className="featureWrapper featureWrapperRecap">
        <h4 className="outbound-title">Fansided.com Featured Articles</h4>
        <ul className="outBoundLinksList">
          {item.map((feature, featureIndex) => (
            <li key={`feature-recap--${featureIndex}`}>
              <OutboundLink
                className="outbound-link"
                target="_blank"
                to={feature.linkExternal}
                eventLabel={feature.linkExternal}
              >
                {feature.title}
              </OutboundLink>
            </li>
          ))}
        </ul>
      </div>
    </article>
  )
}

export default ItemCardFeatureRecap
